import { defaultFeedPriorityArr } from './constants';
export const getFinalOrganizeObj = (priorityData, removedData) => {
    const finalObj = {};
    priorityData.forEach((data, i) => {
        finalObj[data] = i + 1;
    });
    removedData.forEach((data) => {
        finalObj[data] = null;
    });
    return finalObj;
};
export const organizeFeed = (feedPersonalization, hasCompletedSetup, removeCashbackOffers, removeCreditScore, removeGroups) => {
    const finalArr = [];
    const removedArr = [];
    const excluded = {
        completeSetup: hasCompletedSetup,
        cashback: removeCashbackOffers,
        creditScore: removeCreditScore,
        groups: removeGroups,
    };
    defaultFeedPriorityArr
        .filter((item) => !excluded[item])
        .forEach((content) => {
        if (feedPersonalization[content] !== null) {
            finalArr.push(content);
        }
        else {
            removedArr.push(content);
        }
    });
    finalArr.sort((a, b) => {
        const orderOfA = feedPersonalization[a];
        const orderOfB = feedPersonalization[b];
        // keys missing from a saved personalisation are new widgets: they sort
        // last, except creditScore which surfaces first so users who organised
        // their feed before it existed still discover it
        if (orderOfA === null || orderOfA === undefined) {
            return a === 'creditScore' ? -1 : 1;
        }
        if (orderOfB === null || orderOfB === undefined) {
            return b === 'creditScore' ? 1 : -1;
        }
        return orderOfA - orderOfB;
    });
    return {
        priority: finalArr,
        removed: removedArr,
    };
};
export const organizeTabs = (visibleTabs) => {
    const finalArr = [];
    const removedArr = [];
    Object.entries(visibleTabs).forEach(([tab, value]) => {
        if (value !== null) {
            finalArr.push(tab);
        }
        else {
            removedArr.push(tab);
        }
    });
    finalArr.sort((a, b) => {
        const orderOfA = visibleTabs[a];
        const orderOfB = visibleTabs[b];
        if (orderOfA === null || orderOfA === undefined) {
            return 1;
        }
        if (orderOfB === null || orderOfB === undefined) {
            return -1;
        }
        return orderOfA - orderOfB;
    });
    return {
        priority: finalArr,
        removed: removedArr,
    };
};
